import React, { Component, useState } from "react";
import {
  Layout,
  Input,
  Button,
  Card,
  Typography,
  Form,
  Radio,
  message,
  Popover,
  Progress,
} from "antd";
import "./styles.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import UserModal from "../../components/common/Modals/index";
import { UserRegisterApi } from "./api.js";
import { CheckCircleFilled } from "@ant-design/icons";
import { useNavigator } from "../../utilities/navigation";
import { useMutation } from "react-query";
import { utilities } from "../../utilities/utlities";
const Registration = (props) => {
  const [verficationModal, setVerification] = useState(false);
  const naviagte = useNavigate();
  const [ModalHeader, setModalHeader] = useState("Verify email");
  const [icon, setIcon] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("distributor");
  const [passwordLength, setpasswordLength] = useState(false);
  const [passwordChar, setpasswordChar] = useState(false);
  const [passwordNumber, setpasswordNumber] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [navigator] = useNavigator();
  const [emailError, setEmailError]= useState(false);
  const mutation = useMutation(
    (data) => {
      return UserRegisterApi.createNewUser(data);
    },
    {
      onSuccess: (data) => {
        console.log(data);
        if (data?.data != undefined) {
          if (data?.data?.success == false) {
            message.error(data?.data?.message, 3);
          } else {
            message.success("Successfully created", 10);
            setType("distributor");
            setFirstName("");
            setLastName("");
            setPassword("");
            setEmail("");
            navigator("/login");
          }
        } else {
          message.error("Something Went Wrong", 3);
        }
      },
      onError: (error) => {
        setType("distributor");
        setFirstName("");
        setLastName("");
        setPassword("");
        setEmail("");
        message.error(error.message, 10);
      },
    }
  );

  console.log("email is ")
  console.log(email)

  const openModal = (value) => {
    setVerification(value);
  };
  const onCreateUser = (data) => {
    if (type == "") {
      return;
    }
    if (firstName == "") {
      return;
    }

    if (lastName == "") {
      return;
    }
    if (password == "") {
      return;
    }
    if (email == "") {
      return;
    }
    if(emailError == true){
      return;
    }
    mutation.mutateAsync(data);
  };
  const { Content } = Layout;
  const { Title, Text, Link } = Typography;
  return (
    <>
      <UserModal
        visible={verficationModal}
        ModalHeader={ModalHeader}
        openModal={openModal}
      />
      <Layout className="layout">
        {/* <CustomHeader /> */}
        <Content style={{ padding: "0 50px" }} className="Registration-content">
          <div className="site-layout-content1">
            <Card
              style={{ width: 300 }}
              bordered={true}
              className="login-container"
            >
              <Form
                autoComplete="off"
                className="loginForm"
                layout="vertical"
                name="nest-messages"
                onFinish={() => {}}
                validateMessages={() => {}}
              >
                <Form.Item>
                  <Title level={5} className="form-title">
                    Register to Sehahub
                  </Title>
                </Form.Item>
                <Form.Item
                  name="radio-group"
                  label="Registration Role:"
                  className="form-elemnt"
                >
                  <Radio.Group
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                    defaultValue={type}
                  >
                    <Radio value="distributor">Distributor</Radio>
                    <Radio value="supplier">Supplier</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  className="form-elemnt"
                  name="firstname"
                  label="First Name"
                  rules={[
                    {
                      required: true,
                      // message: "Please input your First Name",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                    value={firstName}
                  />
                </Form.Item>
                <Form.Item
                  className="form-elemnt"
                  name="lastname"
                  label="Last Name"
                  rules={[
                    {
                      required: true,
                      // message: "Please input your Last Name!",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                    value={lastName}
                  />
                </Form.Item>
                <Form.Item
                  className="form-elemnt error"
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Please input valid email!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value) {
                          return Promise.resolve();
                        }
                         else if (
                          !utilities.workingEmail(value.toLowerCase())
                        ) {
                          console.log(email)
                          utilities?.validateEmail(email)
                          setEmailError(true)
                          // setTimeout(()=>{
                          //   setEmailError(false)  
                          // }, 3000)
                          return Promise.reject(
                            new Error("Please enter working email")
                          );
                        }
                        else{
                          setEmailError(false)
                        }
                      },
                    }),
                  ]}
                >
                  <Input
                    size="large"
                    type="email"
                    onChange={(e) => {
                      setEmail(e.target.value);
                      // handleEmail(e);
                    }}
                    value={email}
                  />
                </Form.Item>
                <Form.Item
                  className="form-elemnt"
                  name="password"
                  autoComplete="off"
                  label="Create Password"
                  help="Use at least 8 characters"
                  rules={[
                    {
                      required: true,
                      // message: "Please input your password!",
                    },
                  ]}
                >
                  <Popover
                    placement="bottomLeft"
                    title="Your Password must have:"
                    content={
                      <>
                        <div className="password_validation">
                          <div className="password_indicator">
                            <CheckCircleFilled
                              className={`${
                                passwordLength == true
                                  ? "icon-indicator-complete"
                                  : "icon-indicator-uncomplete"
                              }`}
                            />
                            <Text type="secondary">8 or more character</Text>
                          </div>
                          <div className="password_indicator">
                            <CheckCircleFilled
                              className={`${
                                passwordChar == true
                                  ? "icon-indicator-complete"
                                  : "icon-indicator-uncomplete"
                              }`}
                            />
                            <Text type="secondary">
                              Upper and Lowercase letter
                            </Text>
                          </div>
                          <div className="password_indicator">
                            <CheckCircleFilled
                              className={`${
                                passwordNumber == true
                                  ? "icon-indicator-complete"
                                  : "icon-indicator-uncomplete"
                              }`}
                            />
                            <Text type="secondary">Atleast One Number</Text>
                          </div>
                          <Text type="secondary">Strength:</Text>
                          <Progress percent={percentage} showInfo={false} />
                        </div>
                      </>
                    }
                    trigger="click"
                  >
                    <Input
                      size="large"
                      autoComplete="off"
                      type="password"
                      onChange={(e) => {
                        if (e.target.value.length > 8) {
                          setpasswordLength(true);
                          setPercentage(((percentage + 1) * 100) / 3);
                        } else {
                          setpasswordLength(false);
                          if (percentage > 0) {
                            setPercentage(((percentage - 1) * 100) / 3);
                          }
                        }
                        if (
                          /[a-z]/.test(e.target.value) &&
                          /[A-Z]/.test(e.target.value)
                        ) {
                          setPercentage(((percentage + 1) * 100) / 3);
                          setpasswordChar(true);
                        } else {
                          setpasswordChar(false);
                          if (percentage > 0) {
                            setPercentage(((percentage - 1) * 100) / 3);
                          }
                        }
                        if (/\d/.test(e.target.value)) {
                          setpasswordNumber(true);
                          setPercentage(((percentage + 1) * 100) / 3);
                        } else {
                          setpasswordNumber(false);
                          if (percentage > 0) {
                            setPercentage(((percentage - 1) * 100) / 3);
                          }
                        }
                        setPassword(e.target.value);
                      }}
                      value={password}
                    />
                  </Popover>
                </Form.Item>
                <Form.Item className="form-elemnt">
                  <Text>
                    By registering, you are indicating that you have read and
                    agree to SEHAHUB.{" "}
                    <Link href="https://ant.design" target="_blank">
                      Terms of Use
                    </Link>{" "}
                    and{" "}
                    <Link href="https://ant.design" target="_blank">
                      Privacy policy
                    </Link>
                    .
                  </Text>
                </Form.Item>
                <Form.Item className="submit-item">
                  <Button
                    type="primary"
                    className="submit-btn reg-btn"
                    htmlType="submit"
                    size="large"
                    loading={mutation.isLoading}
                    onClick={() => {
                      onCreateUser({
                        type: type,
                        firstName: firstName,
                        lastName: lastName,
                        password: password,
                        email: email,
                      });
                    }}
                  >
                    Register
                  </Button>
                </Form.Item>
              </Form>
            </Card>
            <Card
              style={{ width: 300 }}
              className="login-container Register-container"
            >
              <Form
                className="loginForm"
                layout="vertical"
                name="nest-messages1"
                onFinish={() => {}}
                validateMessages={() => {}}
              >
                <Form.Item className="Do-have-account">
                  <Text>Already have an account ?</Text>
                </Form.Item>
                <Form.Item className="submit-item">
                  <Button
                    type="primary"
                    className="submit-btn form-elemnt"
                    htmlType="submit"
                    size="large"
                    // className="reg-btn"
                    onClick={() => {
                      naviagte("/login");
                    }}
                  >
                    <Link className="submit-btn form-elemnt" to="/login">
                      Login
                    </Link>
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Content>
        {/* <CustomFooter /> */}
      </Layout>
    </>
  );
};

export default Registration;
